export const deleteObjectKeys = (object: Record<number | string, any>, keys: string[]) =>
  Object.fromEntries(Object.entries(object).filter(([deleteKey]) => !keys.includes(deleteKey)));
